import * as React from 'react';
//import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider, observer } from 'mobx-react';
import Header from './header/Header';
//import routes from '../config/routes';
import LoggedinUser from '../models/LoggedinUser';
import Login from '../pages/login/Login';
import Home from '../pages/home/Home';
import Balances from '../pages/balances/Balances';
import Subscriptions from '../pages/subscriptions/Subscriptions';
// import Footer from './footer/Footer';
import NotSubscriber from '../pages/notsubscriber/NotSubscriber';
import NoDataFound from '../pages/nodatafound/NoDataFound';
import TabsBar from './tabsbar/TabsBar';
import Drawer from '@material-ui/core/Drawer';
import * as ReactGA from 'react-ga';
import Favicon from 'react-favicon';
import { getNoBrand } from '../index';

interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}


@observer
export default class App extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }>  {
  render() {
    const noBrand = getNoBrand();
    const branding = noBrand ? ('nobrand') : (this.props.loggedinUser.branding.brandingName);
    const brandingFavicon = require('../images/branding/' + branding + '/favicon.ico');
    return (
      <div>
        <Favicon url={brandingFavicon} />
        <TabsBar loggedinUser={this.props.loggedinUser} />
        {/* <Header loggedinUser={this.props.loggedinUser} /> */}
        <div id="page-wrapper" className="page-wrapper">
          {checkToken(this.props.loggedinUser)}
          {renderPage(this.props.loggedinUser)}
        </div>
        {/* <div className="footerDiv">
          <Footer loggedinUser={this.props.loggedinUser} />
        </div> */}
      </div>
    );

  }
}

function checkToken(loggedinUser: typeof LoggedinUser.Type) {  
  // First check if we are unauthenticated
  if (!loggedinUser.isauthenticated && !loggedinUser.isLoggingIn) {
    // Check if security token is present and try to login
    let token: string | null = sessionStorage.getItem('msat');
    if (token) {
      loggedinUser.properties.setLoginName(token);
      loggedinUser.view.setLoginForm('tokenlogin');
      loggedinUser.login('tokenlogin');
    } else {
      token = localStorage.getItem('msat');
      if (token) {
        loggedinUser.properties.setLoginName(token);
        loggedinUser.view.setLoginForm('tokenlogin');
        loggedinUser.login('tokenlogin');
      }
    }
  }
}


function renderPage(loggedinUser: typeof LoggedinUser.Type) {
  // console.log('App.renderPage ' + loggedinUser.view.page);
  ReactGA.pageview(loggedinUser.view.currentUrl);
  switch (loggedinUser.view.page) {
    case '':
    case 'login':
      // Check that we are not in progress with a token login
      if (!loggedinUser.isauthenticated &&
        (loggedinUser.view.loginForm !== 'tokenlogin')) {
        return <Login loggedinUser={loggedinUser} />;
      }      
    case 'home':
      return <Home loggedinUser={loggedinUser} />;      
    case 'balances':
      return <Balances loggedinUser={loggedinUser} />;      
    case 'subscriptions':
      return <Subscriptions loggedinUser={loggedinUser} />;
    case 'notsubscriber':
      return <NotSubscriber loggedinUser={loggedinUser} />;
    case 'nodatafound':
      return <NoDataFound loggedinUser={loggedinUser} />;
    default:
      return 'Sidan finns ej';
  }
}






// WEBPACK FOOTER //
// ./src/components/App.tsx